import React from 'react';
import PropTypes from 'prop-types';
import { useTabsNavigationStore, APP_VIEWS } from '../../../stores';

// .shift-tabs — табы смен текущего сезона (название + даты).
export default function ShiftTabs({ shifts }) {
    const selectedShiftId = useTabsNavigationStore(state => state.selectedShiftId);
    const currentView = useTabsNavigationStore(state => state.currentView);
    const setShift = useTabsNavigationStore(state => state.setShift);
    const showShifts = useTabsNavigationStore(state => state.showShifts);

    if (!shifts || shifts.length === 0) return null;

    const sortedShifts = [...shifts].sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    const inShifts = currentView === APP_VIEWS.SHIFTS;

    const handleSelect = (shiftId) => {
        if (!inShifts) showShifts();
        setShift(shiftId);
    };

    return (
        <div className="shift-tabs">
            {sortedShifts.map(shift => {
                const active = inShifts && selectedShiftId === shift.id;
                const range = `${shift.startDate}${shift.endDate ? ` – ${shift.endDate}` : ''}`;
                return (
                    <button
                        type="button"
                        key={shift.id}
                        className={`item${active ? ' on' : ''}`}
                        onClick={() => handleSelect(shift.id)}
                    >
                        <div className="n">{shift.title}</div>
                        <div className="d">{range}</div>
                    </button>
                );
            })}
        </div>
    );
}

ShiftTabs.propTypes = {
    shifts: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string
    })).isRequired
};
